<template>
    <v-layout wrap class="profile__achievments" :class="{'px-3': $vuetify.breakpoint.xs}">
        <v-layout v-if="user_page.achievments" class="md4 profile__achievments-item align-center" :class="{'px-2': $vuetify.breakpoint.xs}">
            <img :src="url + user_page.achievments.image" alt="chevron" class="mt-2">
            <v-flex class="ml-2">{{ $t(user_page.achievments.name) }}</v-flex>
            <!-- <v-flex v-if="user_page.self" class="text-xs-right mr-4"><router-link :to="{name: 'points_history'}" class="link link--green">{{$t("Карта достижений")}}</router-link></v-flex> -->
        </v-layout>
        <v-layout v-if="isValid" class="md4 profile__achievments-item align-center" :class="{'px-2': $vuetify.breakpoint.xs}">
            <div class="grey-text ml-4">{{ $t("Рейтинг") }}:</div>
            <v-flex class="headline red-text ml-2">{{ rating }}</v-flex>
        </v-layout>
        <v-layout class="md4 profile__achievments-item align-center" :class="{'px-2': $vuetify.breakpoint.xs}">
            <div class="grey-text ml-4">{{ $t("Баллы") }}:</div>
            <div class="headline red-text ml-2">{{ user_page.points }}
                <!-- <span v-if="user_page.self" class="ml-1"> ({{ user_page.points_changing}})</span> -->
            </div>
            <!-- <v-flex v-if="user_page.self" class="text-xs-right mr-4 ml-2"><router-link :to="{name: 'prize_shop'}" class="link link--green">{{$t("Магазин призов")}}</router-link></v-flex> -->
        </v-layout>
        <v-layout class="md4 profile__achievments-item align-center" :class="{'px-2': $vuetify.breakpoint.xs}">
            <div class="grey-text ml-4">{{ $t("Дата регистрации") }}:</div>
            <v-flex class="ml-2 mr-2">{{ user_page.register_date }}</v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import linkGreen from '@/components/ui/links/styled/link_green';
import {mapState, mapGetters, mapMutations} from 'vuex';
import api from '@/api';
export default {
  components: {
    linkGreen,
  },
  props: {
    user_page: {
      type: Object,
    },
  },
  data() {
    return {
      rating: '',
      user  : localStorage.getItem('user') || '',
    };
  },
  mounted() {
    this.getRating();
  },
  methods: {
    async getRating() {
      const getRating = await api.rating.get_rating(this.$route.params.id);
      this.rating = getRating.data;
    },
  },
  computed: {
    ...mapState('common', [
      'url',
    ]),
    isValid() {
      const user = JSON.parse(localStorage.getItem('user'));
      const accessUserRole = ['ADMINISTRATOR', 'ORGANIZATION_EMPLOYEE', 'REPLACEMENT_PERSON']
      if (user.id === this.user_page.id || accessUserRole.includes(user.role_code)) {
        return true;
      }
      return false;
    },
  },
};
</script>

